import Cache from './screens/Cache/cache';
import GraphiQLView from './screens/GraphiQLView';
import GraphQLVoyagerView from './screens/GraphQLVoyagerView';
import Autocompletion from './screens/Hurdle/Autocompletion';
import InputView from './screens/InputView';
import StacktraceView from './screens/StacktraceView';
import UserView from './screens/UserView';
import MassGift from './screens/MassGift';
import VersionControl from './screens/VersionControl';
import UpdateGiftHistory from './screens/UpdateGiftHistory';
import UnsupportedPopup from './screens/UnsupportedPopup';
import SubscriptionFeatureToggles from './screens/SubscriptionFeatureToggles';
import ExportImportProgress from './screens/ExportImportProgress';

export const PREFIX = 'sp3';

export default [
  {
    path: `/${PREFIX}/devtools/table`,
    component: InputView,
    name: 'Data Look Up',
  },
  {
    path: `/${PREFIX}/devtools/userview/:userid?`,
    name: 'User View',
    component: UserView,
  },
  {
    path: `/${PREFIX}/devtools/stacktrace/`,
    name: 'Stacktrace',
    component: StacktraceView,
  },
  {
    path: `/${PREFIX}/devtools/autocompletion/`,
    name: 'Song Autocompletion Test',
    component: Autocompletion,
  },
  {
    path: `/${PREFIX}/devtools/caches/`,
    name: 'Cache tools',
    component: Cache,
  },
  {
    path: `/${PREFIX}/devtools/graphql`,
    name: 'GraphQL',
    component: GraphiQLView,
  },
  {
    path: `/${PREFIX}/devtools/graphql-viz`,
    name: 'GraphQL Vizualizer',
    component: GraphQLVoyagerView,
  },
  {
    path: `/${PREFIX}/devtools/massgift`,
    name: 'Mass Gifting',
    component: MassGift,
  },
  {
    path: `/${PREFIX}/devtools/versioncontrol`,
    name: 'NVS Campaigns',
    component: VersionControl,
  },
  {
    path: `/${PREFIX}/devtools/update-gift-history`,
    name: 'Client Update Gift',
    component: UpdateGiftHistory,
  },
  {
    path: `/${PREFIX}/devtools/unsupported-popup`,
    name: 'Unsupported Pop Up',
    component: UnsupportedPopup,
  },
  {
    path: `/${PREFIX}/devtools/subscription-feature-toggles`,
    name: 'Subscription Toggles',
    component: SubscriptionFeatureToggles,
  },
  {
    path: `/${PREFIX}/devtools/export-import-progress`,
    name: 'Export-Import Progress',
    component: ExportImportProgress,
  },
];
